import Formular from "@views/Formular.vue";
import QuestionForm from "@views/forms/QuestionForm.vue";

export default [
  {
    path: "/formular/:id",
    name: "Formular",
    component: Formular,
  },
  {
    path: "/forms/question/:id",
    name: "QuestionForm",
    component: QuestionForm,
  },
];
